import script from "./PhoneSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneSelector.vue?vue&type=script&setup=true&lang=js"

import "./PhoneSelector.vue?vue&type=style&index=0&id=6d529c8a&lang=scss"
import "./PhoneSelector.vue?vue&type=style&index=1&id=6d529c8a&lang=sass"

const __exports__ = script;

export default __exports__